/* global $, Modernizr */

const $navigation = $('.js-navigation');
const $navigationOverlay = $('.js-nav-overlay');
const $toggler = $('.js-nav-toggler');

const navigation = {
  initialize() {
    if (!$navigationOverlay.length) {
      return;
    }

    this.createListeners();
  },

  createListeners() {
    $toggler.on(Modernizr.touchevents ? 'touchstart' : 'click', () => {
      this.toggleNavigation();
    });

    $navigationOverlay.on('mouseenter mouseleave', '.js-nav-overlay-link', ({ currentTarget }) => {
      this.toggleActiveState($('.nav-overlay__link'), currentTarget);
    });

    $navigation.on('mouseenter mouseleave', '.js-navigation-link', ({ currentTarget }) => {
      this.toggleActiveState($('.nav-main__navigation-link'), currentTarget);
    });
  },

  toggleNavigation() {
    const isOpen = $navigationOverlay.hasClass('is-open');

    $navigationOverlay.toggleClass('is-open', !isOpen);
    $toggler.toggleClass('is-open', !isOpen);
    $toggler
      .attr('aria-expanded', !isOpen)
      .find('.nav-toggler__text')
      .text(isOpen
        ? $toggler.find('.nav-toggler__text').data('collapsed-text')
        : $toggler.find('.nav-toggler__text').data('expanded-text'));
  },

  toggleActiveState(element, target) {
    element.not($(target)).toggleClass('not-active');
  },
};

export default navigation;
